import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Backdrop from "@material-ui/core/Backdrop";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputAdornment from "@material-ui/core/InputAdornment";
import Add from "@material-ui/icons/Add";
import Delete from "@material-ui/icons/Delete";
import Search from "@material-ui/icons/Search";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import Button from "components/CustomButtons/Button";
import CustomInput from "components/CustomInput/CustomInput";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Table from "components/Table/Table";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { cloneDeep, isEmpty, remove, isEqual, isUndefined } from "lodash";
import { ERROR_MESSAGE } from "../../../messages/index";
import { findObjByKey } from "../../../helpers/common";
import {
  clearSFItem,
  deleteMappingData,
  mappingLogicData,
} from "../../../business/mappingLogic";
import {
  fetchMapping,
  fetchMappingInfo,
  fetchSchema,
  fetchUpdateMapping,
} from "../../../services/api.salesforce";

export default function SFHisMapping() {
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state);
  const { authentication: { user: { company_id } } } = userInfo;
  const [isOpen, setIsOpen] = useState(false);
  const [mappingData, setMappingData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [hisObj, setHisObj] = useState("");
  const [sfData, setSfData] = useState([]);
  const [objects, setObjects] = useState([]);
  const [ecData, setEcData] = useState([]);
  const [isFirstRun, setIsFirstRun] = useState(true);
  const [isLoadingBtn, setIsLoadingBtn] = useState(false);
  const [ecOptions, setEcOptions] = useState([]);
  const [sfOptions, setSfOptions] = useState([]);
  const [filterCondition, setFilterCondition] = useState({
    ec_item: "",
    ec_name: "",
    sf_item: "",
    sf_name: "",
  });
  useEffect(() => {
    document.title = "Salesforce通話履歴項目マッピング";
    fetchAllData();
  }, []);


  async function fetchAllData() {
    setIsOpen(true);
    const resMapping = await fetchMapping(dispatch);
    setMappingData(resMapping.data);
    setFilteredData(resMapping.data);


    const resInfo = await fetchMappingInfo(dispatch);
    if (resInfo.isOk) {
      setObjects(resInfo.data.salesforce_objects);
      setEcData(resInfo.data.ec_history_schema);
      setEcOptions(resInfo.data.ec_history_schema);
    }

    if (!isEmpty(resMapping.salesforce_object)) {
      setHisObj(resMapping.salesforce_object);
    } else {
      setIsOpen(false);
    }
  }

  useEffect(() => {
    async function fetchSchemaData() {
      const res = await fetchSchema({ sf_history_obj: hisObj }, dispatch);
      setSfData(res.data.data);
      setSfOptions(res.data.data);
      if (isFirstRun) {
        setIsOpen(false);
        return setIsFirstRun(false);
      }
      setFilteredData((state) => clearSFItem(state));
      setMappingData((state) => clearSFItem(state));
      setIsOpen(false);
    }
    if (hisObj) {
      setIsOpen(true);
      fetchSchemaData();
    }
  }, [hisObj]);

  // // Function handle when select change value
  function handleChangeSelect(index, key, value) {
    setMappingData((state) => {
      let result = cloneDeep(state);
      result[index][key] = value;
      return result;
    });

    // Update filter data state
    setFilteredData((state) => {
      let result = cloneDeep(state);
      result[index][key] = value;
      return result;
    });
  }

  // Function add history mapping
  function addMapping() {
    setMappingData((state) => mappingLogicData(state, company_id));
    setFilteredData((state) => mappingLogicData(state, company_id));
  }

  // Function delete history mapping
  function deleteMapping(index) {
    setMappingData((state) => deleteMappingData(state, index));
    setFilteredData((state) => deleteMappingData(state, index));
  }

  // Function handle when history mapping update
  async function handleUpdate() {
    setIsLoadingBtn(true);
    await fetchUpdateMapping({ history_mapping: mappingData, sf_history_obj: hisObj }, dispatch);
    setIsLoadingBtn(false);
  }

  // Function generate header for table
  function headerTypeData() {
    return [
      <h6 key="ec_name" className="color-red text-bold">
        EVERCALL
      </h6>,
      "",
      <GridContainer
        key="sf_name"
        direction="row"
        justifyContent="space-between"
      >
        <h6 key="sf_name" className="color-blue text-bold">
          SALESFORCE
        </h6>
        <Box sx={{ mr: 2 }}>
          <h6 key="sf_name" className="color-blue text-bold">
            テーブル名
          </h6>
        </Box>
      </GridContainer>,
      <Autocomplete
        key="salesforce_obj"
        disablePortal
        value={hisObj || null}
        options={objects}
        renderInput={(params) => <TextField variant="standard" {...params} />}
        onChange={(_e, val) => setHisObj(val)}
      />,
      "",
    ];
  }

  // Function generate header for table
  function headerData() {
    return [
      <h6 key="ec_name" className="color-red text-bold">
        項目名
      </h6>,
      <h6 key="ec_item" className="color-red text-bold">
        項目KEY
      </h6>,

      <h6 key="sf_name" className="color-blue text-bold">
        項目名
      </h6>,
      <h6 key="sf_item" className="color-blue text-bold">
        項目KEY
      </h6>,
      <h6 key="action"></h6>,
    ];
  }

  // Function generate row search for table
  function searchData() {
    return ["ec_item", "ec_name", "sf_item", "sf_name"].map((item) => (
      <CustomInput
        key={item}
        formControlProps={{
          fullWidth: true,
          className: "input-search",
        }}
        inputProps={{
          onChange: (e) => {
            filterTables(item, e.target.value);
          },
          type: "text",
          endAdornment: (
            <InputAdornment position="end">
              <Search />
            </InputAdornment>
          ),
        }}
      />
    ));
  }

  function removeSelectedItem(key, label) {
    const options = key === "ec_item" ? ecOptions : sfOptions;
    let result = cloneDeep(options);
    const copyData = [...filteredData];
    for (let item of copyData) {
      remove(result, (e) => e.label !== label && e.label === item[key]);
    }
    return result;
  }

  function findSelectedItem(val, key = "ec_item") {
    const items = key === "ec_item" ? ecOptions : sfOptions;
    const obj = findObjByKey(items, "label", val);
    if (isUndefined(obj)) {
      return null;
    }

    return obj;
  }

  // Function generate data body table
  function renderDataTable() {
    const cloneData = [...filteredData];
    let result = [];
    result = cloneData.map((item, index) => {
      const everCall = findObjByKey(ecData, "label", item.ec_item);
      const salesForce = findObjByKey(sfData, "label", item.salesforce_item);

      const temp = [
        <Autocomplete
          disablePortal
          key={item.id}
          value={findSelectedItem(item.ec_item, "ec_item") || null}
          options={removeSelectedItem("ec_item", item.ec_item)}
          isOptionEqualToValue={(option, value) => isEqual(option, value)}
          getOptionLabel={(option) => option.value || ""}
          renderInput={(params) => {
            return <TextField
              helperText={!item.ec_item ? ERROR_MESSAGE.REQUIRED : ""}
              variant="standard" {...params}
              error={!item.ec_item ? true : false}
            />;
          }}
          onChange={(_e, val) => handleChangeSelect(index, "ec_item", val ? val.label : "")}
        />,
        !everCall ? "" : everCall.label,
        <Autocomplete
          disablePortal
          key={item.id}
          value={findSelectedItem(item.salesforce_item, "salesforce_item") || null}
          options={removeSelectedItem("salesforce_item", item.salesforce_item)}
          isOptionEqualToValue={(option, value) => isEqual(option, value)}
          getOptionLabel={(option) => option.value || ""}
          renderInput={(params) => {
            return <TextField
              helperText={!item.salesforce_item ? ERROR_MESSAGE.REQUIRED : ""}
              variant="standard" {...params}
              error={!item.salesforce_item ? true : false} />;
          }}
          onChange={(_e, val) => handleChangeSelect(index, "salesforce_item", val ? val.label : "")}
        />,
        !salesForce ? "" : salesForce.label,
        <Button
          key={item.id}
          justIcon
          color="danger"
          className="btn-history-setting"
          onClick={() => deleteMapping(index)}
        >
          <Delete />
        </Button>,
      ];
      return temp;
    });

    // If filter condition is not empty, filter data
    if (filterCondition["ec_item"] !== "") {
      const lowerCaseData = filterCondition["ec_item"].toLowerCase();
      result = result.filter(
        (e) => e[0].props.value?.toLowerCase().indexOf(lowerCaseData) >= 0
      );
    }

    // If filter condition is not empty, filter data
    if (filterCondition["ec_name"] !== "") {
      const lowerCaseData = filterCondition["ec_name"].toLowerCase();
      result = result.filter(
        (e) => e[1].toLowerCase().indexOf(lowerCaseData) >= 0
      );
    }

    // If filter condition is not empty, filter data
    if (filterCondition["sf_item"] !== "") {
      const lowerCaseData = filterCondition["sf_item"].toLowerCase();
      result = result.filter(
        (e) => e[2].props.value?.toLowerCase().indexOf(lowerCaseData) >= 0
      );
    }

    // If filter condition is not empty, filter data
    if (filterCondition["sf_name"] !== "") {
      const lowerCaseData = filterCondition["sf_name"].toLowerCase();
      result = result.filter(
        (e) => e[3].toLowerCase().indexOf(lowerCaseData) >= 0
      );
    }
    // Add search row to table
    result.unshift(searchData());

    // Add header to table
    result.unshift(headerData());

    // Add header type to table
    result.unshift(headerTypeData());

    return result;
  }

  // Function handle when input search change data
  function filterTables(key, value) {
    setFilterCondition({ ...filterCondition, [key]: value });
  }

  // Function to disable button
  function disabledAddFilter(salesforce, evercall, filterData) {
    if (!salesforce || !evercall) {
      return false;
    }

    let selectedEvercall = [];
    let selectedsaleforce = [];
    for (let item of filterData) {
      selectedEvercall.push(item.ec_item);
      selectedsaleforce.push(item.salesforce_item);
    }

    // If data of filter data is equal evercall or salesforce data
    if (
      selectedEvercall.length === evercall.length ||
      selectedsaleforce.length === salesforce.length
    ) {
      return true;
    }

    return false;
  }

  function enableBtn() {
    if (!hisObj || mappingData.length === 0) {
      return true;
    }

    return mappingData.some(
      (el) => el.ec_item === undefined || el.ec_item === "" || el.ec_item === null || el.salesforce_item === undefined || el.salesforce_item === "" || el.salesforce_item === null
    );
  }


  return (
    <>
      <Box className="backdrop">
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isOpen}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </Box>
      <GridContainer direction="row">
        <GridItem xs={12}>
          <Card>
            <CardHeader>
              <h3 className="text-bold text-dark-grey">
                通話履歴項目マッピング
              </h3>
              <GridContainer direction="row">
                <GridItem xs={10}>
                  <h6 className="text-grey">
                    Salesforceにデータを連携するため、
                    <br />
                    Evercall項目とマッピングルールを定義してください。
                  </h6>
                </GridItem>
                <GridItem xs={2} align="right">
                  <LoadingButton
                    color="secondary"
                    disabled={enableBtn()}
                    loading={isLoadingBtn}
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    variant="contained"
                    onClick={handleUpdate}
                  >
                    保存
                  </LoadingButton>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <GridContainer direction="row">
                <GridItem xs={12} align="center">
                  <Box className="history-mapping-table">
                    <Table
                      isDisableOverflow
                      tableData={renderDataTable()}
                    />
                  </Box>
                </GridItem>
              </GridContainer>
              <GridContainer direction="row">
                <GridItem xs={12} align="right">
                  <Button
                    justIcon
                    className="btn-history-setting"
                    onClick={addMapping}
                    disabled={disabledAddFilter(
                      sfData,
                      ecData,
                      filteredData
                    )}
                  >
                    <Add />
                  </Button>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </>
  );
}
